import { SuccessNotifications } from 'components/Notification';
import React, { FC, useEffect } from 'react';
import { translationKeys, useTranslation } from 'services/localization';
import { trackDisplaySuccessUnsubscribeAllBanner } from '../../../../services/userActionEvents';
import { ActionNotificationMessageProps } from '../../types';
import { Stack, Text } from '@atlaskit/primitives';
import { LearnMoreAction } from '../Actions';

const SuccessGlobalUnsubscribe: FC<ActionNotificationMessageProps> = ({ onClose }) => {
  const { translate } = useTranslation();

  useEffect(() => {
    trackDisplaySuccessUnsubscribeAllBanner();
  }, []);

  return (
    <SuccessNotifications
      title={translate(translationKeys.NOTIFICATION_GLOBAL_UNSUBSCRIBE_MESSAGE_TITLE)}
      onClose={onClose}
      actions={[<LearnMoreAction key={'learn-more'} />]}
    >
      <Stack space='space.100'>
        <Text as='p'>{translate(translationKeys.NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_PRIMARY)}</Text>
        <Text as='p'>{translate(translationKeys.NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_SECONDARY)}</Text>
      </Stack>
      <Text size='small'>{translate(translationKeys.NOTIFICATION_UNSUBSCRIBE_MESSAGE_BODY_TERTIARY)}</Text>
    </SuccessNotifications>
  );
};

export default SuccessGlobalUnsubscribe;
